module.exports = __webpack_public_path__ + "static/img/logo2.9172957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/logo2.png
// module id = 9iYT
// module chunks = 1